import { httpPost } from "utils/httpRequest"

export const listAiBatches = async (payload) => {
  const resp = await httpPost("admin/ai-platform/batches/list", payload)
  return resp.data.data
}

export const getAiBatchDetail = async (batchId) => {
  const resp = await httpPost("admin/ai-platform/batches/detail", { batchId })
  return resp.data.data
}

export const updateAiBatchItem = async (batchId, itemId, afterJson) => {
  const resp = await httpPost("admin/ai-platform/batches/update-item", {
    batchId,
    itemId,
    afterJson,
  })
  return resp.data.data
}

export const approveAiBatch = async (batchId) => {
  const resp = await httpPost("admin/ai-platform/batches/approve", { batchId })
  return resp.data
}

export const rejectAiBatch = async (batchId) => {
  const resp = await httpPost("admin/ai-platform/batches/reject", { batchId })
  return resp.data
}

export const approveAiBatches = async (batchIds) => {
  const resp = await httpPost("admin/ai-platform/batches/approve-batch", { batchIds })
  return resp.data
}

export const rejectAiBatches = async (batchIds) => {
  const resp = await httpPost("admin/ai-platform/batches/reject-batch", { batchIds })
  return resp.data
}
